var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {
        const slider = new Swiper('.block-blog-related-articles .swiper-container', {
            spaceBetween: 20,
            slidesPerView: 1.5,
            autoHeight: true,
            loop: false,
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=blog-related-articles', initializeBlock);
    }
});
